import React from 'react';

export const Container: React.FC = (props) => {
    return (
      <div className="container">{props.children}</div>
    );
  }


export const PaddedContainer: React.FC = (props) => {
    return (
      <div className="container padded-container">{props.children}</div>
    );
  }
